import tinycolor from "tinycolor2";
import { isJson } from "@shared/utils/functions";

export const parseThemeData = (payload) => {
  const themeData = (isJson(payload) ? JSON.parse(payload) : payload) || null;
  return themeData;
}

export const getColorValues = (colors) => {
  return Object.entries(colors).reduce((result, [color, colorData]) => {
    const value = colorData?.value || colorData;
    if (value) {
      result[color] = value;
    }
    return result;
  }, {});
}

/*
  To add a new shade to color add a new color to:
  - state.colors
  - its default value to shared/assets/styles/style.scss
  - new color to tailwind.config.js theme.extend.colors
*/
export const colorShades = [
  {
    postfix: "50",
    make: (color) =>
      tinycolor(color)
        .lighten(60)
        .toHex8String(),
  },
  {
    postfix: "100",
    make: (color) =>
      tinycolor(color)
        .lighten(45)
        .toHex8String(),
  },
  {
    postfix: "200",
    make: (color) =>
      tinycolor(color)
        .lighten(25)
        .toHex8String(),
  },
  {
    postfix: "300",
    make: (color) =>
      tinycolor(color)
        .lighten(12)
        .toHex8String(),
  },
  {
    postfix: "400",
    make: (color) =>
      tinycolor(color)
        .lighten(3)
        .toHex8String(),
  },
  {
    postfix: "500",
    make: (color) =>
      tinycolor(color)
        .darken(2)
        .toHex8String(),
  },
  {
    postfix: "600",
    make: (color) =>
      tinycolor(color)
        .darken(5)
        .toHex8String(),
  },
  {
    postfix: "700",
    make: (color) =>
      tinycolor(color)
        .darken(9)
        .toHex8String(),
  },
  {
    postfix: "800",
    make: (color) =>
      tinycolor(color)
        .darken(12)
        .toHex8String(),
  },
];